<template>
  <a
    :href="applyUrl"
    :aria-label="text"
    @click.prevent.stop="goToApplyPage"
  >
    {{ text }}
  </a>
</template>

<script setup>
import useEncryption from '~/composables/useEncryption';

const route = useRoute();
const { applyDataEncryptionKey, applyUrl } = useRuntimeConfig().public;
const { $analytics } = useNuxtApp();

const props = defineProps({
  text: {
    type: String,
    default: 'Apply now',
  },
  ctaSection: {
    type: String,
    required: true,
  },
  pageName: {
    type: [String, null],
    default: null,
  },
  additionalData: {
    type: Object,
    default: () => ({}),
  },
});

function goToApplyPage() {
  const initialPageAndSource = useCookie('initialPageAndSource');
  const trafficSource = useCookie('career_traffic_src');

  const dataToSend = {
    cta_name: props.text,
    page_name: props.pageName,
    cta_section: props.ctaSection,
    form_id: `${props.pageName}-${props.ctaSection}`,
    target_page: trafficSource.value?.ga_landing_page,
    campaign_name: trafficSource.value?.ga_campaign,
    campaign_source: trafficSource.value?.ga_source,
    campaign_medium: trafficSource.value?.ga_medium,
    campaign_keyword: trafficSource.value?.ga_keyword,
    campaign_content: trafficSource.value?.ga_content,
    gclid: trafficSource.value?.ga_gclid,
    first_visited_page: initialPageAndSource.value?.initialPage,
    first_visited_source: initialPageAndSource.value?.initialSource,
    last_landing_page: sessionStorage.getItem('last_landing_page'),
    ...props.additionalData,
  };

  $analytics.track('CTA Clicked', {
    cta_name: props.text,
    page_name: props.pageName || route.name,
    section: props.ctaSection,
  });

  const encryptedData = useEncryption(applyDataEncryptionKey).encrypt(
    dataToSend
  );

  window.location.href = `${applyUrl}?t_data=${encryptedData}`;
}
</script>
